import React from 'react';
import Footer from '../components/Footer';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-4xl px-6 py-16">
        <h1 className="text-3xl font-bold text-gray-900">Terms of Use</h1>
        <p className="mt-2 text-sm text-gray-500">Last updated: February 11, 2026</p>

        <section className="mt-8 space-y-4 text-gray-700">
          <p>
            By using Together On Mission (the &quot;App&quot;), you agree to these terms.
            If you do not agree, do not use the App.
          </p>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Age Requirement</h2>
          <p>
            Together On Mission is intended for users who are 18 years of age or older.
            By creating an account, you confirm that you are at least 18 years old.
            All individuals communicated with through the App&mdash;including disciples,
            organization members, and message recipients&mdash;must also be 18 years of
            age or older. You agree not to use the App to contact or manage information
            for anyone under 18.
          </p>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Use of the App</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You must provide accurate account information.</li>
            <li>You are responsible for activity under your account.</li>
            <li>Do not misuse the App or interfere with other users.</li>
          </ul>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Content</h2>
          <p>
            You retain ownership of content you submit, but you grant us permission to
            host, display, and distribute that content within the App and its community
            features.
          </p>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Organizations and Seats</h2>
          <p>
            Organizations may purchase seat packages through the web app. Seat access is
            managed by organization admins and is separate from personal use of the App.
          </p>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Termination</h2>
          <p>
            We may suspend or terminate accounts that violate these terms or the law.
            You may delete your account at any time.
          </p>
        </section>

        <section className="mt-10 space-y-3 text-gray-700">
          <h2 className="text-xl font-semibold text-gray-900">Contact</h2>
          <p>
            Questions about these terms? Email us at
            {' '}
            <a className="text-blue-600 hover:underline" href="mailto:support@togetheronmission.org">
              support@togetheronmission.org
            </a>.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;
